import ProductPage from "../../components/ProductPage";
import { loansData } from "../../data/productsData";
export default function Loans() { return <ProductPage data={loansData} />; }